"use client";

import { useCallback, useRef } from "react";
import { randomId } from "@/lib/random-id";

export function useSubmissionKey() {
  const keyRef = useRef<string | null>(null);

  const current = useCallback(() => {
    keyRef.current ??= randomId();
    return keyRef.current;
  }, []);

  const reset = useCallback(() => {
    keyRef.current = null;
  }, []);

  return { current, reset };
}
